import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.regexp.to-string.js";
import Vue from 'vue';
import iframeResize from 'iframe-resizer/js/iframeResizer';
/*
  按钮防抖动指令
*/
Vue.directive('debounce', {
  inserted: function inserted(el, binding) {
    el.addEventListener('click', function () {
      if (!el.disabled) {
        el.disabled = true;
        setTimeout(function () {
          el.disabled = false;
        }, binding.value || 1000);
      }
    });
  }
});
Vue.directive('enter', {
  bind: function bind(el, binding) {
    document.documentElement.onkeyup = function (e) {
      e.code === 'Enter' && binding.value();
    };
  },
  update: function update(el, binding) {
    if (binding.oldValue !== binding.value || !document.documentElement.onkeyup) {
      document.documentElement.onkeyup = function (e) {
        if (binding.modifiers.dailogNo && document.querySelector('.el-dialog__wrapper')) {
          return;
        }
        e.code === 'Enter' && binding.value();
      };
    }
  },
  unbind: function unbind() {
    document.documentElement.onkeyup = null;
  }
});
Vue.directive('el-drag-dialog', {
  bind: function bind(el, binding, vnode) {
    var dialogHeaderEl = el.querySelector('.el-dialog__header');
    var dragDom = el.querySelector('.el-dialog');
    dialogHeaderEl.style.cssText += ';cursor:move;';
    dragDom.style.cssText += ';top:0px;';

    // 获取原有属性 ie dom元素.currentStyle 火狐谷歌 window.getComputedStyle(dom元素, null);
    var getStyle = function () {
      if (window.document.currentStyle) {
        return function (dom, attr) {
          return dom.currentStyle[attr];
        };
      } else {
        return function (dom, attr) {
          return getComputedStyle(dom, false)[attr];
        };
      }
    }();
    dialogHeaderEl.onmousedown = function (e) {
      // 鼠标按下，计算当前元素距离可视区的距离
      var disX = e.clientX - dialogHeaderEl.offsetLeft;
      var disY = e.clientY - dialogHeaderEl.offsetTop;
      var dragDomWidth = dragDom.offsetWidth;
      var dragDomheight = dragDom.offsetHeight;
      var screenWidth = document.body.clientWidth;
      var screenHeight = document.body.clientHeight;
      var minDragDomLeft = dragDom.offsetLeft;
      var maxDragDomLeft = screenWidth - dragDom.offsetLeft - dragDomWidth;
      var minDragDomTop = dragDom.offsetTop;
      var maxDragDomTop = screenHeight - dragDom.offsetTop - dragDomheight;

      // 获取到的值带px 正则匹配替换
      var styL = getStyle(dragDom, 'left');
      var styT = getStyle(dragDom, 'top');
      if (styL.includes('%')) {
        styL = +document.body.clientWidth * (+styL.replace(/%/g, '') / 100);
        styT = +document.body.clientHeight * (+styT.replace(/%/g, '') / 100);
      } else {
        styL = +styL.replace(/\px/g, '');
        styT = +styT.replace(/\px/g, '');
      }
      document.onmousemove = function (x) {
        // 通过事件委托，计算移动的距离
        var left = x.clientX - disX;
        var top = x.clientY - disY;

        // 边界处理
        if (-left > minDragDomLeft) {
          left = -minDragDomLeft;
        } else if (left > maxDragDomLeft) {
          left = maxDragDomLeft;
        }
        if (-top > minDragDomTop) {
          top = -minDragDomTop;
        } else if (top > maxDragDomTop) {
          top = maxDragDomTop;
        }

        // 移动当前元素
        dragDom.style.cssText += ";left:".concat(left + styL, "px;top:").concat(top + styT, "px;");

        // emit onDrag event
        vnode.child.$emit('dragDialog');
      };
      document.onmouseup = function () {
        document.onmousemove = null;
        document.onmouseup = null;
      };
    };
  }
});
var elementUiSet = new Set(['el-button', 'el-input', 'el-radio', 'el-checkbox', 'el-switch', 'el-select', 'el-select-dropdown__item', 'el-slider', 'el-date-editor', 'el-time-picker', 'el-breadcrumb__item', 'el-menu-item', 'el-tab-pane', 'el-dropdown', 'el-link', 'el-tree', 'el-tree-node']);
Vue.directive('test-id', {
  inserted: function inserted(el) {
    var rootClassName = el.classList[0] && '';
    var uniqueId = rootClassName + Date.now().toString(16);
    var allElements = el.querySelectorAll('*');
    var len = allElements.length;
    for (var i = 0; i < len; i++) {
      var element = allElements[i];
      var className = element.classList[0] && '';
      var isEvents = element && element.__vue__ && element.__vue__._events && element.__vue__._events;
      if (isEvents || elementUiSet.has(className)) {
        !element.hasAttribute('id') && element.setAttribute('id', "".concat(uniqueId, "_").concat(className, "_").concat(i));
      }
    }
  }
});
Vue.directive('resize', {
  bind: function bind(el, _ref) {
    var _ref$value = _ref.value,
      value = _ref$value === void 0 ? {} : _ref$value;
    el.addEventListener('load', function () {
      return iframeResize(value, el);
    });
  },
  unbind: function unbind(el) {
    el.iFrameResizer.removeListeners();
  }
});